import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import * as Yup from "yup";
import { t } from "@lingui/macro";
import { I18n } from "@lingui/react";
import { Button, FieldText, CheckSingle, color } from "@conserveit/blocks";
import { withFormik } from "formik";
import { Wrapper } from "../../Auth/Login/Login.styles";
import { FormContainer, Header, Content, Footer } from "./AuthForm.styles";

const ForgotPassword = ({
  values,
  status,
  errors,
  handleChange,
  handleBlur,
  handleSubmit,
  isSubmitting,
}) => (
  <Wrapper>
    <div className="Wrapper-inner">
      <I18n>
        {({ i18n }) => (
          <FormContainer onSubmit={handleSubmit}>
            <Header data-cy="AuthForm-header">
              {i18n._(t("forgot_password.form_title")`Forgot Password`)}
            </Header>
            <Content>
              <FieldText
                name="username"
                onChange={handleChange}
                error={errors.username}
                value={values.username}
                onBlur={handleBlur}
                disabled={isSubmitting || status.success}
                placeholder={i18n._(
                  t(
                    "forgot_password.username_placeholder"
                  )`Enter your username...`
                )}
                help={i18n._(
                  t(
                    "forgot_password.instructions"
                  )`Enter the username or email address assocated with your account. We'll email you with a password reset link.`
                )}
              />
            </Content>
            <Footer>
              {!status.success ? (
                <Button type="submit" primary>
                  {i18n._(t("forgot_password.submit")`Submit`)}
                </Button>
              ) : (
                <Button type="button" disabled>
                  <CheckSingle tiny />
                </Button>
              )}
            </Footer>
          </FormContainer>
        )}
      </I18n>
    </div>
  </Wrapper>
);

ForgotPassword.propTypes = {
  status: PropTypes.shape({
    success: PropTypes.bool,
  }),
  values: PropTypes.shape({
    username: PropTypes.string.isRequired,
  }).isRequired,
  errors: PropTypes.shape({
    username: PropTypes.string,
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
};

ForgotPassword.defaultProps = {
  status: {},
};

export default withFormik({
  validateOnBlur: false,
  validateOnChange: false,
  handleSubmit: (values, { setSubmitting, setErrors, setStatus }) => {
    axios
      .post("/auth/forgot", { username: values.username })
      .then(() => {
        setStatus({ success: true });
      })
      .catch((err) => {
        setErrors({ username: err.response.data.message });
      })
      .then(() => setSubmitting(false));
  },
  mapPropsToValues: () => ({
    username: "",
  }),
  validationSchema: Yup.object({
    username: Yup.string().required(),
  }),
})(ForgotPassword);
